import { css } from "styled-components";
import { focusTokens } from "../config/designTokens";

/**
 * Standardized focus ring mixin for accessibility compliance (WCAG 2.1 AA)
 * 
 * @param color - Color of the focus ring (defaults to theme brand color)
 * @param width - Width of the ring (defaults to token focus.ring.width)
 * @param offset - Offset of the ring (defaults to token focus.ring.offset)
 */
export const focusRing = (
    color?: string,
    width: string = focusTokens.ring.width,
    offset: string = focusTokens.ring.offset,
    style: string = focusTokens.ring.style
) => css`
    outline: ${width} ${style} ${color || "currentColor"};
    outline-offset: ${offset};
`;
